module.exports = __webpack_public_path__ + "static/media/green.be4bb426.webp";